import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppVersionComponent } from '@tango/app/app-version';

const routes: Routes = [
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./+dashboard').then((m) => m.BankDashboardModule),
  },
  {
    path: 'accounts',
    loadChildren: () => import('./+accounts').then((m) => m.AccountsModule),
  },
  {
    path: 'payments',
    loadChildren: () => import('./+payments').then((m) => m.BankPaymentsModule),
  },
  {
    path: 'deposits',
    loadChildren: () => import('./+deposits').then((m) => m.BankDepositsModule),
  },
  {
    path: 'credits',
    loadChildren: () => import('./+credits').then((m) => m.BankCreditsModule),
  },
  {
    path: 'notifications',
    loadChildren: () =>
      import('@tango/app/+notifications').then((m) => m.NotificationsModule),
  },
  {
    path: 'profile',
    loadChildren: () => import('./+profile').then((m) => m.ProfileModule),
  },
  {
    path: 'registration',
    loadChildren: () =>
      import('./+registration').then((m) => m.BankRegistrationModule),
  },
  {
    path: 'app-version',
    component: AppVersionComponent,
  },
  {
    path: 'redirecting',
    redirectTo: 'redirecting',
  },
  {
    path: '**',
    redirectTo: 'login',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
